

<div class=" flex-grow-1 p-0 d-flex flex-column bg">
  <div class=" flex-grow-1 d-flex flex-column">
    <div class="d-flex justify-content-between flex-wrap align-items-center">
      <div class="search-cont">
        <div class="s-in form-input" style="position:relative">
          <mat-icon class="input-icon">search</mat-icon>
          <input type="text"  placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control" [(ngModel)]="searchInput"    (input)="onSearch($event)" (keyup.enter)="onGo()" />

        </div>
        <div class="go-b" (click)="onGo()">{{'COMMON.GO' | translate}}</div>
        <div class="s-item d-box " (click)="onFilterView()">
          <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
        </div>
      </div>
      <div class="s-lbtn" *ngIf="isCourseBuilder">
        <button mat-raised-button color="primary" class=" primary-btn  mb-2 mb-md-0 no-sh-btn" type="submit" (click)="onAddCourse()">
          <i class="fas fa-plus text-white"></i> {{'COMMON.CREATE' | translate}} {{'COURSE.TEXT' | translate}}</button>          

      </div>
    </div>
    <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
    <div class="heading-2 mt-3"><span *ngIf="isCourseBuilder">{{'COURSE.TEXT' | translate}} {{'COURSE.BUILDER' | translate}}</span> <span *ngIf="!isCourseBuilder">{{'COURSE.TEXT' | translate}} {{"MENUITEMS.DASHBOARD.TEXT" | translate}}</span> 
      <div class="s-bt cursor-pointer"  (click)="onAddCourse()" *ngIf="isCourseBuilder"> <i class="fas fa-plus text-white"></i> {{'COMMON.CREATE' | translate}} {{'COURSE.TEXT' | translate}}</div>
    </div>
    <div class=" flex-grow-1 position-relative" *ngIf="isSpinnerLoading">
      <div class="custom-loader"></div>
    </div>
    <div class="row " *ngIf="!isSpinnerLoading">
      <div class="col-12  col-sm-6  col-md-4 col-xxl-3 d-flex flex-column"
        *ngFor="let item of filteredItems;let i=index">
        <div class="c-box h-100 d-flex flex-column">
          <div class="c-img cursor-pointer" [appBackgroundImg]="item.img" [iType]="'course'"
            (click)="onViewCourse(item.c_i,item.pc_id,item.admin_course,item.t)"></div>          
          <div class="c-content d-flex flex-column flex-grow-1">
            <div class="d-flex justify-content-between head">
              <div class="heading-3">{{item.tit | truncate:32}}</div>
              <i class="material-icons cursor-pointer more-ic" [matMenuTriggerFor]="menu">more_vert</i>
              <mat-menu #menu="matMenu">           
                <button mat-menu-item color="primary" (click)="onEditCourse(item)"
                  *ngIf="(item.admin_course == 'no') || isAdmin">
                  <mat-icon class="kt-margin-r-0">create</mat-icon>
                  <span>{{'COURSE.EDIT' | translate}}</span>
                </button>

                <button mat-menu-item color="warn" (click)="onCoursePreview(item)" type="button">
                  <mat-icon class="kt-margin-r-0">visibility</mat-icon>
                  <span>{{"COURSE.PREVIEW" | translate}}</span>
                </button>

                 <!-- (click)="onViewCourse(item.c_i,item.pc_id,item.admin_course,item.t)" *ngIf="!isAdmin && userType=='company'"> -->
                <button mat-menu-item color="primary" matTooltip=""
                  (click)="onViewCourse(item.c_i,item.pc_id,item.admin_course,item.t)" *ngIf="!isAdmin">
                  <mat-icon class="kt-margin-r-0">people</mat-icon>
                  <span>{{"COMMON.ASSIGNEDLIST" | translate}} </span>
                </button>
  

                <button mat-menu-item color="warn" (click)="onDeleteCourse(item.c_i,item.t)" type="button">
                  <mat-icon class="kt-margin-r-0">delete</mat-icon>
                  <span>{{'BUTTON.DELETE' | translate}}</span>
                </button> 

              </mat-menu>
            </div>
            <div class="small-text grey2 course-sub-cont mb-0 c-desc line-clamp-2 mt-1" [innerHtml]="item.desc | truncate:95:'desc' "></div>
            <div class="flex-grow-1 d-flex flex-column justify-content-end">
              <!-- No need to show assigned and completed to individual or admin -->
              <div class="d-flex mt-3 ic-box sub-content flex-wrap" *ngIf="!isAdmin && (userType!='individual')">
                <div class="d-flex  align-items-center me-4 assign-txt">
                  <span>{{'COMMON.ASSIGN' | translate}}:</span>
                  <i class="material-icons mat-icons">person</i>
                  <span class="total">{{item.t_a_c }}</span>
                </div>
                <div class="d-flex  align-items-center me-2 assign-txt">
                  <span>{{"STATUS.COMPLETED" | translate}}:</span>
                  <i class="material-icons mat-icons comp">person</i>
                  <span class="total">{{item.t_comp }}</span>
                </div>
              </div>
              <div *ngIf="(item.admin_course != 'no') && !isAdmin">
                <label class="mb-1 mt-3 small-text">{{"COURSE.REMAININGCOURSE" | translate}}</label>
                <div class="p-bar d-flex align-items-center ">
                  <mat-progress-bar mode="determinate" class="green-progress"
                      [value]="calculatePercentage(item.t_a_c,item.emp_u)"></mat-progress-bar>
                  <span class="text-bold text black per mx-3">{{item.t_a_c }}/{{item.emp_u}}</span>
               </div>
              </div>
             
              <div class="d-flex justify-content-center  flex-wrap">
                <button mat-raised-button color="primary" class="primary-btn no-sh-btn w-100 mt-3  mt-xl-4"  *ngIf="(item.admin_course == 'no') || isAdmin"
                  type="button" (click)="onManageExam(item.c_i,item.e_t,item.is_info)">
                  <img src="assets/images/icons/manage_exam.png" class="img-fluid me-1">{{"COURSE.MANAGEEXAM" | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mat-table__message" *ngIf="courseArr.length==0 && !isSpinnerLoading">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
    </div>
    <div class=" pagination-cont " *ngIf="filteredItems.length!=0">
      <div class="show-item">
        {{"COMMON.SIP" | translate}}
        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
          <option [value]="item" *ngFor="let item of pageSizeOptions">
            {{ item }}
          </option>
        </select>
      </div>
      <div class="page-c">
        <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
          [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
      </div>
    </div>
  </div>
</div>
